/*

Renders a collapsable menu

*/
import { useState } from "react";

const Menu = ({ menuTitle, subMenus = [] }) => {
  const [isOpen, setIsopen] = useState(true);

  const toggleDropDown = () => {
    setIsopen((isOpen) => !isOpen);
  };

  return (
    <div className="flex-item nopad">
      <div className="flex-item button" onClick={toggleDropDown}>
        <div className="flex-apart">
          <h4 className="nopad">{menuTitle}</h4>
          <h6 className="nopad indentLeft">{isOpen ? "<" : "v"}</h6>
        </div>
      </div>
      {isOpen && <div className="row-container">{subMenus}</div>}
    </div>
  );
};

export default Menu;